// Authorization actions

import * as types from './actionTypes';
import * as authUtils from '../../services/authUtils';
import { notifyError } from './notificationActions';
import { getLocalStorage, setLocalStorage } from '../../services/storageUtils';

const KEY_MARKET = 'market';
const KEY_CATEGORY = 'category';
const KEY_BRAND = 'brand';

export function authSetUser(user, error = null) {
    if (user) {
        if (user.market) {
            setLocalStorage(KEY_MARKET, user.market);
        } else {
            if (user.setMarket(getLocalStorage(KEY_MARKET))) {
                setLocalStorage(KEY_MARKET, user.market);
            }
        }
        if (user.category) {
            setLocalStorage(KEY_CATEGORY, user.category);
        } else {
            if (user.setCategory(getLocalStorage(KEY_CATEGORY))) {
                setLocalStorage(KEY_CATEGORY, user.category);
            }
        }
        if (user.brand) {
            setLocalStorage(KEY_BRAND, user.brand);
        } else {
            if (user.setBrand(getLocalStorage(KEY_BRAND))) {
                setLocalStorage(KEY_BRAND, user.brand);
            }
        }
    }
    return { type: types.AUTH_SET_USER, user, error };
}

export function authReloadRequest() {
    return function (dispatch) {
        return Promise.resolve()
            .then(() => authUtils.getCurrentUser())
            .then((user) => dispatch(authSetUser(user)))
            .catch((error) => dispatch(authSetUser(null, error)));
    };
}

export function authNoSession(error) {
    return function (dispatch, getState) {
        const { auth } = getState();
        if (auth.user) {
            dispatch(authSetUser(null, error));
            dispatch(notifyError((L) => L.msg_logged_out));
        }
    };
}
